<template lang="pug">
    div.emailItem

        // Email subject
        div.emailSubject {{ item.subject }}

        // Launch Date
        div
            date-picker(
                :label="$t('fields.sendDate')"
                :predefinedDate="startDate"
                :datePickerCallback="startDateCallback"
            )

        // Launch time
        div
            time-picker(
                :label="$t('fields.sendTime')"
                :predefinedTime="startTime"
                :timePickerCallback="startTimeCallback"
            )

        div

            // Edit business button
            button-component(:action="() => setEmail({ index: itemIndex, data: item })" color="white" icon="edit")

            // Delete business button
            button-component(:action="() => deleteEmail(itemIndex)" color="white" icon="delete")

</template>

<script>
    import ButtonIcon from '~components/ButtonIcon';
    import DatePicker from '~components/Picker/DatePicker';
    import TimePicker from '~components/Picker/TimePicker';
    import dayjs from 'dayjs';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';

    export default {
        components: {
            TimePicker,
            DatePicker,
            ButtonComponent: ButtonIcon
        },
        props: {
            item: VueTypes.object.def({}),
            itemIndex: VueTypes.number.def(-1)
        },
        data() {
            return {
                selectedTime: '',
                selectedDate: ''
            };
        },
        computed: {
            startDate() {
                return dayjs(this.item.sendAt).format('YYYY-MM-DD');
            },
            startTime() {
                if (this.item.sendAt) {
                    return dayjs(this.item.sendAt).format('HH:mm');
                }

                return dayjs()
                    .add(1, 'hour')
                    .format('HH:mm');
            }
        },
        methods: {
            ...mapActions('businesses', ['addLaunchDate', 'deleteEmail']),
            ...mapActions('emails', ['setEmail']),

            startDateCallback(date) {
                this.selectedDate = date;
                const time = this.selectedTime
                    ? this.selectedTime
                    : this.startTime;
                this.setDateTime(date, time);
            },
            startTimeCallback(time) {
                this.selectedTime = time;
                const date = this.selectedDate
                    ? this.selectedDate
                    : this.startDate;
                this.setDateTime(date, time);
            },

            setDateTime(date, time) {
                const dateTime = dayjs(`${date} ${time}`);
                this.addLaunchDate({
                    itemIndex: this.itemIndex,
                    date: dateTime,
                    routingKey: 'email'
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .emailItem
        display: flex
        align-items: center
        justify-content: space-between
        padding: 5px 15px
        margin: 5px 0
        border: 1px solid rgba($theme.white, 0.5)
        background: $theme.primary

    .emailSubject
        width: 240px
        overflow: hidden
        text-overflow: ellipsis
</style>
